var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "swiper-container-pagination",
      class: { nograb: !_vm.moreThanOne, "single-picture": _vm.singlePic },
      attrs: { id: _vm.id },
    },
    [
      _c(
        "div",
        {
          staticClass: "swiper-container",
          on: {
            click: function ($event) {
              return _vm.openSingleGallery()
            },
          },
        },
        [
          _c("div", { staticClass: "swiper-wrapper" }, [_vm._t("default")], 2),
          _vm._v(" "),
          _vm.moreThanOne
            ? _c("div", { staticClass: "swiper-pagination" })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "zoom-gallery",
          on: {
            click: function ($event) {
              return _vm.openGallery()
            },
          },
        },
        [_c("span", { staticClass: "icon-zoom-swiper" })]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "swiper-button-prev-taaf" }, [
      _c("span", { staticClass: "icon-arrow-right" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "swiper-button-next-taaf" }, [
      _c("span", { staticClass: "icon-arrow-right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }